import React from "react";
import { Grid } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import * as Icons from "react-bootstrap-icons"
import { useTranslation } from 'react-i18next';

function Pricing() {
  const { t } = useTranslation();
  return (
    <Grid container className="p-1 h-100">
      <Grid item xs={12} className="alert alert-danger p-2 d-flex flex-column justify-content-center align-items-center m-auto shadow-lg" style={{'maxWidth':'400px', 'minHeight':'230px'}}>
          <p className="text-danger">
            <Icons.Calendar2X size={40}/>
          </p>
          <h6 className="mt-2">
            {t('expiredPanel')}
          </h6>

          <h6 className="mt-2">
            {t('contactAdminDepartment')}
          </h6>
          
          <h6 className="mt-2">
            {t('thanks')}
          </h6>
      </Grid>
    </Grid>
  );
}

export default Pricing;
